import {type CmLogger, NoopLogger} from "@cm/log"

export let sceneLogger: CmLogger = NoopLogger

export function setThreeTextureStreamingSceneLogger(logger: CmLogger): void {
    sceneLogger = logger
}
